export default function isIntersected(candidates, pool) {
  // The pool is invalid or empty.
  if (!Array.isArray(pool) || pool.length === 0) {
    return false;
  }
  const _candidates = Array.isArray(candidates) ? candidates : [candidates];
  const intersection = _candidates.filter(val => pool.includes(val));
  return intersection.length > 0;
}